import {Fragment, useMemo} from 'react';

import {ClientDevice} from 'interfaces';
import {UrlService} from 'services';

import {ClientConferenceWebContent} from '../ClientConferenceWeb';
import {ClientNotifier} from '../ClientNotifier';
import {ClientSessionStartupContainer} from '../SessionStartupContainer';
import {ClientAppearanceFeatures} from '../types';

import {ClientConferenceSDKInterface, ClientConferenceSDKInterfaceOld} from './ClientConferenceSDKInterface';
import {ClientConferenceVideoOnlyContent} from './ClientConferenceVideoOnly';
import {IosSDKEventNotifier, AndroidSDKEventNotifier, SDKMethodNotifier} from './ClientNotifier';

type Props = {
    device: ClientDevice;
    clientNotifier: ClientNotifier;
    defaultFeatures?: ClientAppearanceFeatures;
    oldInterface?: boolean;
}

export const ClientConferenceSDK: React.FC<Props> = ({
    device, clientNotifier, defaultFeatures = ClientAppearanceFeatures.All, oldInterface
}) => {
    const features = useMemo(() =>
        UrlService.getSearchParamValue('features') as ClientAppearanceFeatures || defaultFeatures, [defaultFeatures]);

    return (
        <ClientSessionStartupContainer device={device} clientNotifier={clientNotifier} features={features}>
            <Fragment>
                {oldInterface ? <ClientConferenceSDKInterfaceOld /> : <ClientConferenceSDKInterface />}
                {features === ClientAppearanceFeatures.All && <ClientConferenceWebContent />}
                {features === ClientAppearanceFeatures.Video && <ClientConferenceVideoOnlyContent />}
            </Fragment>
        </ClientSessionStartupContainer>
    );
};

export const ClientConferenceAndroidSDK: React.FC = () => {
    const clientNotifier = useMemo(() => new AndroidSDKEventNotifier(), []);

    return <ClientConferenceSDK device={ClientDevice.AndroidSDK} clientNotifier={clientNotifier} />;
};

export const ClientConferenceAndroidSDKOld: React.FC = () => {
    const clientNotifier = useMemo(() => new SDKMethodNotifier(), []);

    return (
        <ClientConferenceSDK
            device={ClientDevice.AndroidSDK}
            clientNotifier={clientNotifier}
            oldInterface
            defaultFeatures={ClientAppearanceFeatures.Video}
        />
    );
};

export const ClientConferenceIosSDK: React.FC = () => {
    const clientNotifier = useMemo(() => new IosSDKEventNotifier(), []);

    return <ClientConferenceSDK device={ClientDevice.IosSDK} clientNotifier={clientNotifier} />;
};

/**
 * For testing purposes only, should not be used in production
 */
export const ClientConferenceIosSDKOld: React.FC = () => {
    const clientNotifier = useMemo(() => new SDKMethodNotifier(), []);

    return (
        <ClientConferenceSDK
            device={ClientDevice.IosSDK}
            clientNotifier={clientNotifier}
            oldInterface
            defaultFeatures={ClientAppearanceFeatures.Video}
        />
    );
};
